export default {
  drugName: 'Drug Name',
  strength: 'Strength',
  // POM-6305: smartphos-core reports an order-acceptance rejection under this key.
  orderRejection: 'Reason',
};
